export default __webpack_public_path__ + "static/media/_Design.ff903a95.svg";